import {Component} from '@angular/core';
import {FieldWrapper} from '@ngx-formly/core';

@Component({
  selector: 'app-formly-checkbox-wrapper',
  standalone: true,
  template: `
    <div class="checkbox-wrapper">
      <ng-container #fieldComponent></ng-container>
    </div>
  `,
})
export class CheckboxWrapper extends FieldWrapper {}
